import { useState, useEffect } from "react";
import { AlertaProps } from "@/types";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string | number;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  error?: string | boolean | AlertaProps;
  className?: string;
}

export function Input({
  className = "",
  value,
  onChange,
  error,
  disabled,
  readOnly,
  ...props
}: Props) {
  const isDisabled = disabled || readOnly;

  // Estado local para manejar el fondo dinámico
  const [bgColor, setBgColor] = useState(
    error ? "bg-red-100" : "bg-white"
  );

  // Cambiar fondo cuando el usuario escribe y hay error
  useEffect(() => {
    if (error && value) {
      setBgColor("bg-white");
    } else if (error) {
      setBgColor("bg-red-100");
    } else {
      setBgColor("bg-white");
    }
  }, [error, value]);

  return (
    <input
      value={value}
      onChange={onChange}
      disabled={disabled}
      readOnly={readOnly}
      {...props}
      className={`
        w-full px-3 py-1 rounded-md
        border border-zinc-600
        ${bgColor} text-zinc-700 placeholder:text-zinc-400
        ${isDisabled ? "cursor-not-allowed shadow-none" : "shadow-[inset_-2px_-2px_1px_rgb(99,105,112)] focus:shadow-[inset_2px_3px_2px_rgb(24,25,27)]"}
        outline-none
        transition-all duration-200
        ${className}
      `}
    />
  );
}

export default Input;
